import React, { useCallback, useContext } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import UniversalCreateButton from '@atlassian/universal-create';

import { withFlags } from '@confluence/flags';
import { START } from '@confluence/navdex';
import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';
import { useIsEligibleForSurfaceImport } from '@confluence/import-from-sources';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage';
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';
import { useIsNav4Enabled } from '@confluence/nav4-enabled';
import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

import { useMenuItems } from './useMenuItems';

const Create = ({ flags }) => {
	const items = useMenuItems(flags);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { match } = useContext(RoutesContext);
	const isNav4Enabled = useIsNav4Enabled();
	const isOnEditRoute = useIsEditorPage();
	const { isEligibleForSurfaceImport } = useIsEligibleForSurfaceImport();

	// Surface imports - #cconboarding
	const [, fireConfluenceSurfaceImportExperiment] = UNSAFE_noExposureExp(
		'confluence_surface_import',
	);

	const onCreateClick = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'globalCreateContentPopover',
				source: 'globalNavigation',
				attributes: {
					selectedItemPageContext: match?.name,
					navigationLayer: 'global',
					navigationContainer: 'top',
					navVersion: isNav4Enabled ? '4' : '3',
					navdexPointType: START,
					isOnEditRoute,
				},
			},
		}).fire();
		isEligibleForSurfaceImport && fireConfluenceSurfaceImportExperiment();
	}, [
		createAnalyticsEvent,
		fireConfluenceSurfaceImportExperiment,
		isEligibleForSurfaceImport,
		isNav4Enabled,
		isOnEditRoute,
		match?.name,
	]);
	return <UniversalCreateButton items={items} onClick={onCreateClick} />;
};

const CreateWithFlags = withFlags(Create);

export function UniversalCreate() {
	return (
		<TransparentErrorBoundary attribution={Attribution.NAVX}>
			<CreateWithFlags />
		</TransparentErrorBoundary>
	);
}
